(() => {
  document.addEventListener('pointerdown', (event) => {
    const active = document.activeElement;
    if (!active || !active.matches('input:not([type="hidden"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]')) return;
    if (event.composedPath().includes(active)) return;
    const label = event.target instanceof Element ? event.target.closest('label') : null;
    if (label && label.control === active) event.preventDefault();
    active.blur();
  }, true);
})();
